<template>
  <div class="container-fluid">
    <template v-if="isLoadingInstructor">
      <div class="pb-2">
        <skeleton-loading>
          <skeleton-square
            :box-properties="{
              height: '16px',
              width: '350px',
            }"
            :count="1"
          />
        </skeleton-loading>
      </div>
    </template>
    <template v-else>
      <h3>
        Clases asignadas a
        {{ `${this.getInstructor.firstname} ${this.getInstructor.lastname}` }}
      </h3>
    </template>
    <div
      class="col-12 row justify-content-between container-instructors__search pr-0 pl-0 ml-0 mb-3"
    >
      <div class="col-7 pl-0">
        <i class="fas fa-search fa-flip-horizontal"></i>
        <input
          v-model="search"
          aria-label="Search"
          class="form-control me-2"
          placeholder="Buscar por nombre"
          type="text"
          @keydown="searchClasses"
        />
      </div>
    </div>
    <div class="container-instructors container-instructors__instructor">
      <div class="container-fluid container-category px-0">
        <md-table>
          <md-table-row class="container-instructors__head">
            <md-table-head>Nombre de la clase</md-table-head>
            <md-table-head></md-table-head>
          </md-table-row>
          <template v-if="isLoadingInstructor">
            <skeleton-course-instructor-course
              v-for="index in 4"
              :key="index"
            />
          </template>
          <template v-else>
            <template
              v-if="this.getInstructor && this.getInstructor.classes.length"
            >
              <md-table-row
                v-for="{ class: classItem } in this.getInstructor.classes"
                :key="classItem.id"
                class="container-instructors__cell"
              >
                <md-table-cell>
                  {{ classItem.title }}
                </md-table-cell>
                <md-table-cell class="container-instructors__options">
                  <span class="float-right">
                    <md-menu
                      :md-offset-x="-147"
                      :md-offset-y="-10"
                      md-size="auto"
                    >
                      <md-button md-menu-trigger>•••</md-button>

                      <md-menu-content v-if="classItem">
                        <md-menu-item>
                          <router-link
                            :to="`/admin/clases/clase/${classItem.id}`"
                            class="dropdown-item-edit p-0"
                          >
                            Editar
                          </router-link>
                        </md-menu-item>
                        <md-menu-item>
                          <div
                            class="dropdown-item p-0"
                            @click="openDeleteInstructorClassDialog(classItem)"
                          >
                            Eliminar
                          </div>
                        </md-menu-item>
                      </md-menu-content>
                    </md-menu>
                  </span>
                </md-table-cell>
              </md-table-row>
            </template>
            <template v-else>
              <md-table-row>
                <md-table-cell class="pt-4 text-center" colspan="4">
                  No hay cursos asignados
                </md-table-cell>
              </md-table-row>
            </template>
          </template>
        </md-table>
      </div>
    </div>
    <delete-dialog
      :is-open="isOpenDeleteInstructorClassDialog"
      @deleted="deleteInstructorClass"
      @close-modal="closeDeleteInstructorClassDialog"
    />
  </div>
</template>

<script>
import {
  DELETE_INSTRUCTOR_CLASS,
  FETCH_INSTRUCTOR,
} from '../../../store/actions/instructor';
import { mapGetters } from 'vuex';
import SkeletonSquare from '../../../components/Skeleton/components/SkeletonSquare';
import SkeletonLoading from '../../../components/Skeleton/SkeletonLoading';
import DeleteDialog from './components/DeleteDialog';
import SkeletonCourseInstructorCourse from '../../Components/skeletons/SkeletonCourseInstructorCourse';

export default {
  components: {
    SkeletonLoading,
    DeleteDialog,
    SkeletonSquare,
    SkeletonCourseInstructorCourse,
  },
  data: function () {
    return {
      selectedCourseInstructorClass: undefined,
      isLoadingInstructor: true,
      isOpenDeleteInstructorClassDialog: false,
      search: '',
    };
  },
  computed: {
    ...mapGetters(['getInstructor']),
  },
  mounted() {
    this.fetchInstructor();
  },
  methods: {
    searchClasses(event) {
      if (event.key === 'Enter') {
        this.fetchInstructor();
      }
    },
    fetchInstructor(
      filter = {
        id: this.$route.params.id,
      },
    ) {
      this.$store
        .dispatch(FETCH_INSTRUCTOR, filter)
        .then(() => (this.isLoadingInstructor = false))
        .catch(() => {
          this.isLoadingInstructor = false;
          this.notify(
            'danger',
            'Tenemos problemas para cargar los datos del instructor',
          );
        });
    },
    openDeleteInstructorClassDialog(classItem) {
      this.selectedCourseInstructorClass = classItem;
      this.isOpenDeleteInstructorClassDialog = true;
    },
    closeDeleteInstructorClassDialog() {
      this.selectedCourseInstructorClass = undefined;
      this.isOpenDeleteInstructorClassDialog = false;
    },
    async deleteInstructorClass() {
      await this.$store
        .dispatch(DELETE_INSTRUCTOR_CLASS, {
          instructorId: this.$route.params.id,
          classId: this.selectedCourseInstructorClass.id,
        })
        .then(() => {
          this.fetchInstructor();
          this.notify('success', 'Clase eliminada correctamente');
          this.closeDeleteInstructorClassDialog();
        })
        .catch(() =>
          this.notify('danger', 'Tenemos problemas para eliminar la clase '),
        );
    },
    notify(type, message) {
      this.$notify({
        type: type,
        verticalAlign: 'top',
        horizontalAlign: 'right',
        message: message,
      });
    },
  },
};
</script>

<style scoped>
.categories {
  border: none !important;
}

.dropdown-item {
  color: #000;
}
a.dropdown-item-edit {
  font-size: 14px !important;
  color: #000 !important;
  text-decoration: none;
}
</style>
